// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"dfb4c9f0","787":"a542a446","996":"9ce4ee40"}[chunkId] + ".chunk.js";
};